import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAms} from '../AM/FormChooseAm.jsx'
import Model from './ModelAo.mjs'

export const FormItemAoName = props => (
    <FormItemBizProp
        Model={Model}
        prop="aoName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemAoNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="aoNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseAo(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemAms />
            <FormItemAoNo />
            <FormItemAoName />
        </FormChooseDesign>
    )
}
